module.exports = __webpack_public_path__ + "static/img/Geos-2022-Alex.6521993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Alex.png
// module id = ZjM2
// module chunks = 0